import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getSchemaProjectType = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project-type-info`
  return doGet(url)
}

export const saveProjectType = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project-type-info`
  return doPost(url, request)
}

export const updateProjectType = (id, request, typeId) => {
  const url = `${API_ROOT}/proposal/${id}/project-type-info/${typeId}`
  return doPut(url, request)
}

export const searchProject = (projectVersionId, projectCode, projectName, year) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/project/reference?projectCode=${projectCode}&projectName=${projectName}&year=${year}`
  return doGet(url)
}

export const searchProjectPaging = (
  projectVersionId,
  pageSize,
  pageNumber,
  projectCode,
  projectName,
  year
) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/project/reference/${pageSize}/paging/${pageNumber}?projectCode=${projectCode}&projectName=${projectName}&year=${year}`
  return doGet(url)
}

export const searchProjectBySearchKeyPaging = (
  projectVersionId,
  pageSize,
  pageNumber,
  searchKey,
  year
) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/project/reference/merger/${pageSize}/paging/${pageNumber}?searchkey=${searchKey}&year=${year}`
  return doGet(url)
}

// -------------------------------- subproject

export const getSubProjectProjectType = (id) => {
  // /api/subproject/{projectVersionId}/project-type-info
  const url = `${API_ROOT}/subproject/${id}/project-type-info`
  return doGet(url)
}

export const saveSubProjectProjectType = (id, request) => {
  // ​/api​/subproject​/{projectVersionId}​/project-type-info
  const url = `${API_ROOT}/subproject/${id}/project-type-info`
  return doPost(url, request)
}

export const updateSubProjectProjectType = (id, request, typeId) => {
  // /api/subproject/{projectVersionId}/project-type-info/{projectTypeInfoId}
  const url = `${API_ROOT}/subproject/${id}/project-type-info/${typeId}`
  return doPut(url, request)
}

// --------------------------------
